import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "plp-add-to-cart-modal-prices__price-skeleton",
  key: "skeleton"
}

import { computed } from 'vue';

import useVariantPrices from '@/composables/useVariantPrices';

import DisplayPrice from '@/components/DisplayPrice.vue';
import Skeleton from '@/components/Skeleton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlpAddToCartModalPrices',
  props: {
  selectedVariant: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;



const selectedVariant = computed(() => props.selectedVariant);

const { unitPrice, campaignPrice, isBusy } = useVariantPrices(selectedVariant);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(isBusy))
      ? (_openBlock(), _createBlock(DisplayPrice, {
          key: 0,
          class: "plp-add-to-cart-modal-prices__variant-price",
          "original-price": _unref(unitPrice),
          "campaign-price": _unref(campaignPrice)
        }, null, 8, ["original-price", "campaign-price"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Skeleton, { class: "plp-add-to-cart-modal-prices__price-skeleton-original" }),
          _createVNode(Skeleton, { class: "plp-add-to-cart-modal-prices__price-skeleton-discounted" })
        ]))
  ]))
}
}

})